
export function truncateStr(str) {
  const beginning = str.substr(0, 3)
  const end = str.substr(-3)
  const truncatedApiKey = `${beginning}...${end}`
  return truncatedApiKey
}